import axios from 'axios'
import store from '@/store'
import { get } from 'lodash'

const base_url = process.env.VUE_APP_API_URL || '/api'

let instance = axios.create({
    baseURL: base_url,
})

instance.interceptors.request.use(
    request => {
        request.headers['Authorization'] =
            'Bearer ' + store.getters['auth/token']
        return request
    },
    err => {
        return Promise.reject(err)
    }
)

instance.interceptors.response.use(
    response => {
        return response
    },
    err => {
        // Logout if we get a 401
        if (get(err, 'response.status') == 401) {
            store.dispatch('auth/logout')
        }
        return err
    }
)

export default instance
